'use client';

import DOMPurify, { Config } from 'dompurify';
import { isClientSide } from './userAgent';

export const sanitize = (htmlString: string, options?: Config): string => {
  return isClientSide
    ? (DOMPurify.sanitize(htmlString, {
        ...options,
        RETURN_DOM: false,
        ADD_TAGS: [
          'iframe',
          ...(Array.isArray(options?.ADD_TAGS) ? options.ADD_TAGS : []),
        ],
      }) as string)
    : '';
};
